import "@astrox/ui-vue/style.css";
import naive from "naive-ui";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { setupRouter } from "./router.ts";

const pinia = createPinia();
const router = setupRouter();

const app = createApp(App);

const meta = document.createElement("meta");
meta.name = "naive-ui-style";
document.head.appendChild(meta);

app.use(naive);
app.use(pinia);
app.use(router);

app.mount("#app");
